// extracted by mini-css-extract-plugin
export default {"modal":"D8iAvTZXgNFTsNJXNZpx","modalContent":"gYDbhnbBWkc79wsmF61z","buttons":"O3wLr40LOQRUAwNrYF1B","duration":"OC98YKdO0vFmN7OjacHF"};